/**
 * 将URL中的查询参数转换为对象
 * [GET]    从config.url中获取参数
 * [POST]   从config.body中获取参数
 * @param   {string} url - 包含查询参数的URL字符串
 * @returns {Object}     - 转换后的对象，键值对形式表示查询参数
 */
const param2Obj = function(url) {
    // 从URL中分割出查询部分
    const search = url.split('?')[1];
    // 如果没有查询部分，则直接返回空对象
    if(!search)
    {
        return {};
    }
    // 将查询字符串转换为对象
    return JSON.parse(
        '{"' + 
            decodeURIComponent(search) // 解码查询字符串
            .replace(/"/g, '\\"')      // 替换双引号为转义的双引号
            .replace(/&/g, '","')      // 将&符号替换为双引号和逗号
            .replace(/=/g, '":"')      // 将等号替换为双引号和冒号
        + '"}'
    );
}

/**
 * 检测设备类型
 */
const isMobile = function() {
    /* const userAgent = navigator.userAgent.toLowerCase();
    if(/iphone|ipad|ipod|android/.test(userAgent))
    {
        console.log('=== common__checkDeviceType__isMobile__1 >>>', 1);
        return true;
    }
    else
    {
        console.log('=== common__checkDeviceType__isMobile__0 >>>', 0);
        return false;
    } */

    // 初始时检测一次设备类型
    let mobileDeviceFlag = isMobileDevice();
    // console.log('=== common__isMobile__mobileDeviceFlag__0 >>>', mobileDeviceFlag);

    // 监听窗口大小变化，动态检测设备类型
    window.addEventListener('resize', () => {
        mobileDeviceFlag = isMobileDevice();
        // console.log('=== common__isMobile__mobileDeviceFlag__resize >>>', mobileDeviceFlag);
    });

    // 返回检测结果：true为移动设备，false为PC设备
    // console.log('=== common__isMobile__mobileDeviceFlag__1 >>>', mobileDeviceFlag);
    return mobileDeviceFlag;
}

/**
 * 检测是否为移动设备
 */
function isMobileDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    // console.log('=== common__isMobileDevice__window__innerWidth >>>', window.innerWidth);
    
    // 返回检测结果：符合约定规则 或者 设备宽度 小于等于768像素，则为移动设备
    return /iphone|ipad|ipod|android/.test(userAgent) || window.innerWidth <= 768;
}

/**
 * 模拟 PHP sprintf 占位符
 */
const toSprintf = function() {
	let _args = arguments, _string = _args[0];
	for(let i = 1; i < _args.length; i++)
	{
		let _item = arguments[i];
		_string   = _string.replace('%s', _item);
	}
	return _string;
}

/**
 * md5(bytesungame2024)
 */
const appKey   = '34f0fadf23caa061a3499e4b91e63f1c';
const makeSign = function(_this, gameId) {
    let _string = appKey + gameId;
	return _this.$Md5(_string);
}

/**
 * 从数组中随机获取指定数量的元素，并将这些元素从原数组中移除
 */
const getRandomItemsFromArray = function(arr, count) {
    const randomItems = [];
    // 结果数组长度小于指定数量 count 并且原始数组 arr 长度大于0（确保在原数组中仍有元素可选）
    while(randomItems.length < count && arr.length > 0)
    {
        const randomIndex  = Math.floor(Math.random() * arr.length);// 生成一个随机索引 randomIndex，范围是从 0 到原数组 arr 的长度减 1
        const selectedItem = arr.splice(randomIndex, 1)[0];         // 使用 splice 方法从原数组中删除随机索引位置的元素，并将其保存到变量 selectedItem 中
        randomItems.push(selectedItem);                             // 将选取的元素 selectedItem 添加到结果数组 randomItems 中
    }
    return randomItems;
}

/**
 * 从数组中随机获取指定数量的元素，但不从原数组中移除这些元素
 */
const getRandomItemsFromArray1 = function(arr, count) {
    const randomItems = [];
    const arrCopy     = [...arr];// 创建原数组的副本

    // 结果数组长度小于指定数量 count 并且副本数组 arrCopy 长度大于 0
    while(randomItems.length < count && arrCopy.length > 0)
    {
        const randomIndex  = Math.floor(Math.random() * arrCopy.length);// 生成一个随机索引
        const selectedItem = arrCopy.splice(randomIndex, 1)[0];         // 从副本数组中删除随机索引位置的元素
        randomItems.push(selectedItem);                                 // 将选取的元素添加到结果数组中
    }
    return randomItems;
}

/**
 * 缓存 - GET
 */
const getCache = function(key, cacheExpire) {
    const cache = localStorage.getItem(key);
    if(cache)
    {
        const { data, time } = JSON.parse(cache);
        if(Date.now() - time < cacheExpire)
        {
            return data;
        }
    }
    return null;
}

/**
 * 缓存 - SET
 */
const setCache = function(key, data) {
    localStorage.setItem(key, JSON.stringify({
        data,
        time: Date.now()
    }));
}

/**
 * 缓存 - REMOVE
 */
const removeCache = function(key) {
    localStorage.removeItem(key);
}

/**
 * 导出全局变量 ---------------------------------------------------------------------
 */
export default {
	param2Obj,
    isMobile,
    toSprintf,
    makeSign,
    getRandomItemsFromArray, 
    getRandomItemsFromArray1, 
    getCache, 
    setCache,
    removeCache
}
